import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Box, Container } from '@mui/material';

interface PageTitleWrapperProps {
  children?: ReactNode;
}

const PageTitleWrapper: FC<PageTitleWrapperProps> = ({ children }) => {
  return (
    <Box
      className="MuiPageTitle-wrapper"
      sx={{
        padding: (theme) => theme.spacing(4)
      }}
    >
      <Container maxWidth="lg">{children}</Container>
    </Box>
  );
};

PageTitleWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageTitleWrapper;
